import { withAuth } from './';

export function dispatchWithAuth (dispatch) {
    return (args, type) => withAuth(
    {method: 'get', ...args},
    (resp) => dispatch({type: type, payload: resp})
  );
}

export function fetchProject (id) {
    const url = `/projects/${id}`;

    return dispatch => {
        dispatch({
            type: 'SET_CURRENT_PROJECT',
            payload: id
        });

        dispatchWithAuth(dispatch)({ url }, 'FETCH_INFO_FULFILLED')
    }
}

export function fetchPermissions (id) {
    const url = `/projects/${id}/permissions`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_PERMISSIONS_FULFILLED')
}

export function fetchPermissionsByModule (moduleId) {
    const url = `/projects/${moduleId}/permissionsbymodule`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_PERMISSIONS_FULFILLED_MODULE')
}

export function fetchNotifications (id) {
    const url = `/projects/${id}/notifications`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_NOTIFICATIONS_FULFILLED')
}

export function fetchProjectTitles () {
    const url = '/projectTitles';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_PROJECT_TITLES_FULFILLED')
}

export function fetchContractors (id) {
    const url = `/projects/${id}/contractors`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACTORS_FULFILLED')
}

export function fetchMembers (id) {
    const url = `/projects/${id}/members`;
    const params = { take: 20 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_MEMBERS_FULFILLED')
}

export function fetchConsultants (id) {
    const url = `/projects/${id}/externalConsultants`;
    const params = { take: 20 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_CONSULTANTS_FULFILLED')
}

export function fetchLocations (id) {
    const url = `/projects/${id}/locations`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_LOCATIONS_FULFILLED')
}

export function fetchGisObjects (id) {
    const url = `/projects/${id}/locations/gisObjects`;
    return dispatch => dispatchWithAuth(dispatch) ({ url }, 'FETCH_GISOBJECTS_FULFILLED')
}

export function fetchSchedule (id) {
    const url = `/projects/${id}/schedule`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_SCHEDULE_FULFILLED')
}

export function fetchBudgets (id) {
    const url = `/projects/${id}/budget`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_BUDGETS_FULFILLED')
}

export function fetchDocuments (id, currentPage) {
    const url = `/projects/${id}/documents`;
    const params = { start: currentPage };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_DOCUMENTS_FULFILLED')
}

export function fetchDocumentTags () {
    const url = '/setup/tags';
    const params = { take: 200 };
    return dispatch => dispatchWithAuth(dispatch)({ url , params }, 'FETCH_DOCUMENT_TAGS_FULFILLED')
}

export function fetchDelayLogs (id) {
    const url = `/projects/${id}/delayLogs`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_DELAY_LOGS_FULFILLED')
}

export function fetchStatusComments (id) {
    const url = `/projects/${id}/statusComments`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_STATUS_COMMENTS_FULFILLED')
}

export function fetchStatusCommentDetails (id, toEditId) {
    const url = `/projects/${id}/statusComments/${toEditId}`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_STATUS_COMMENTDETAILS_FULFILLED')
}

export function fetchProgressReports (id) {
    const url = `/projects/${id}/progressReports`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_PROGRESS_REPORTS_FULFILLED')
}

export function fetchContracts (id) {
    const url = `/projects/${id}/contracts`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACTS_FULFILLED')
}

export function fetchAdjustmentLogs (id, params) {
    const url = `/projects/${id}/adjustmentLogs`;
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_ADJUSTMENT_LOGS_FULFILLED')
}

export function fetchMemberSearch (query) {
    const url = '/members';
    const params = { query };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_MEMBER_SEARCH_FULFILLED')
}

export function fetchActionItems (id) {
    const url = `/projects/${id}/actionItems`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_ACTIONITEM_FULFILLED')
}

export function fetchPriorities () {
    const url = '/projects/actionItemPriorities';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_ACTIONITEM_PRIORITY_FULFILLED')
}

export function fetchCategories () {
    const url = '/projects/actionItemCategories';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_ACTIONITEM_CATEGORY_FULFILLED')
}

export function fetchItems () {
    const url = '/projects/actionItemItems';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_ACTIONITEM_ITEMS_FULFILLED')
}

export function fetchAssignees () {
    const url = '/projects/actionItemAssignees';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_ACTIONITEM_ASSIGNEE_FULFILLED')
}

export function fetchActionItemMembers () {
    const url = '/projects/actionItemMembers';
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_ACTIONITEM_MEMBER_FULFILLED')
}

export function fetchActionItemStatuses () {
    const url = '/projects/actionItemStatuses';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_ACTIONITEM_STATUS_FULFILLED')
}

export function fetchStatusCommentTypes () {
    const url = '/projects/statusCommentTypes';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_STATUSCOMMENT_TYPE_FULFILLED')
}

export function fetchActivitiesIssues () {
    const url = '/projects/activitiesIssues';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_ACTIVITIES_ISSUES_FULFILLED')
}

export function fetchAdvanceSearchResults (query) {
    const url = '/projects/advancesearch';
    const params = { query };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_ADVANCE_SEARCH_FULLFILLED')
}

export function fetchBidPackages (id) {
    const url = `/projects/${id}/BidPackage`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_BID_PACKAGES_FULFILLED')
}
export function fetchBidPkgStatus () {
    const url = '/projects/bidPackageStatus';
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_BID_PACKAGE_STATUS_FULFILLED')
}

export function fetchBidCheckListStatus () {
    const url = '/projects/getCheckListStatus';
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_BID_PKG_CHECKLIST_STATUS_FULFILLED')
}

export function fetchbPkgStList () {
    const url = '/projects/getCheckListStatus';
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_bPkgStList')
}

export function fetchGisCityCouncils () {
    const url = '/projects/gisCityCouncil';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_GIS_COUNCIL_FULFILLED')
}

export function fetchGisAssemblyDist () {
    const url = '/projects/gisAssemblyDisctrict';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_GIS_ASSEMBLY_DISTRICT_FULFILLED')
}

export function fetchGisCommBoard () {
    const url = '/projects/gisCommunityBoard';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_GIS_COMMUNITY_BOARD_FULFILLED')
}
export function fetchGisStateSenateDist () {
    const url = '/projects/gisStateSenateDist';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_GIS_STATE_SENATE_DISTRICT_FULFILLED')
}
export function fetchGisUSCongressionalDist () {
    const url = '/projects/gisUSCongressionalDist';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_GIS_US_CONGRESSIONAL_DISTRICT_FULFILLED')
}
export function fetchFactSheets (id) {
    const url = `/projects/${id}/factSheets`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_FACT_SHEET_FULFILLED')
}

export function fetchConstrReview (id) {
    const url = `/projects/${id}/ConstReview`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONSTR_REVIEW_FULFILLED')
}

export function fetchConstReviewStatus () {
    const url = '/projects/ConstReviewstatus';
    const params = { take: 100 };
    return dispatch => dispatchWithAuth(dispatch)({ url, params }, 'FETCH_CONSTR_REVIEW_STATUS_FULFILLED')
}

export function fetchchartData () {
    const url = '/projects/chartsbyobs';
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CHART_BY_OBS')
}

export function fetchBlueBookData (id) {
    const url = `/projects/${id}/bluebooks`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_BLUEBOOKS')
}

export function fetchDocumentsFep (id) {
    const url = `/projects/${id}/documentsFep`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_DOCUMENTS_FEP_FULFILLED')
}

export function fetchContractorFieldInfo (id) {
  
    const url = `/projects/${id}/contractorsubentities`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACTORFIELDINFO')
}

export function fetchContractsProc (id) {
    const url = `/projects/${id}/contractsproc`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACTSPROC_FULFILLED')
}

export function fetchContractsForDivision (divisionName) {
    const url = `/projects/${divisionName}/contractsForDivision`;
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_CONTRACTS_FOR_DIVISION_FULFILLED')
}

export function fetchAEBidPkgReport () {
    const url = '/projects/AEBidPkgReport';
    return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_AEBIDPKG_REPORT')
}

